// extracted by mini-css-extract-plugin
export default {"inputContainer":"styles_inputContainer__z51ct","labelContainer":"styles_labelContainer__0N-CX"};